import { render } from "./Interpretations.vue?vue&type=template&id=ee2b7cc8&scoped=true"
import script from "./Interpretations.vue?vue&type=script&lang=js"
export * from "./Interpretations.vue?vue&type=script&lang=js"

import "./Interpretations.vue?vue&type=style&index=0&id=ee2b7cc8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee2b7cc8"]])

export default __exports__